<template>
  <el-dialog
    title="审批"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    key="1"
    :modal="false"
    :before-close="handleDialogClose">
    <div>
      <el-form v-if="visible" :model="formData" ref="approvalDialogForm">
        <el-form-item label="输入审批意见" prop="reason"
          :rules="[
            { required: true, message: '审批意见不能为空'}
          ]"
        >
          <el-input type="textarea" v-model.trim="formData.reason" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="submitForm('reject')">拒 绝</el-button>
      <el-button size="small" type="primary" @click="submitForm('agree')">通 过</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ApprovalManageReasonPage',
  props: ['visible'],
  isAutoComponent: true,
  data() {
    return {
      formData: {
        reason: ''
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit('update:visible', false)
    },
    submitForm(type) {
      const that = this
      this.$refs.approvalDialogForm.validate((valid) => {
        if (valid) {
          if (type === 'reject') { // 拒绝
            that.toReject(type)
          }
          if (type === 'agree') { // 同意
            that.toAgree(type)
          }
        } else {
          return false
        }
      })
    },
    toReject(type) {
      const params = JSON.parse(JSON.stringify(this.detailFormData))
      params.systemApproveRemark = this.formData.reason
      this.$api.approval.approveUpdateSystemRefuse(params).then(res => {
        this.toSuccess(type)
      })
    },
    toAgree(type) {
      const params = JSON.parse(JSON.stringify(this.detailFormData))
      params.systemApproveRemark = this.formData.reason
      this.$api.approval.approveUpdateSystemAgree(params).then(res => {
        this.toSuccess(type)
      })
    },
    toSuccess(type) {
      this.$message({ message: type === 'reject' ? '审批拒绝' : '审批通过', type: 'success' })
      this.handleDialogClose()
      this.$emit('refreshData')
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.formData.reason = '同意'
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.approvalManage.approvalDetailData
    })
  }
}
</script>

<style>
</style>
